import confettiGif from './confetti.gif'

export const Confetti = ({
  ...props
}: {
  [key: string]: string | number
}): JSX.Element => {
  return <img src={confettiGif} {...props} alt="ta-da" />
}
